module.exports = __webpack_public_path__ + "static/media/all.4a2813b6.pred";